import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { lg, md, xl, xl2 } from '../common';
import { sideBySideCompare } from '../lib/sideBySideCompare';

export function initWowSlider() {
  const parent = document.querySelector('.js-wow-slider');
  if (!parent) return;

  const compareElements = parent.querySelectorAll('.side-by-side-compare');
  compareElements.forEach((el) => sideBySideCompare(el));

  const swiper = parent.querySelector('.swiper');
  const prevEl = parent.querySelector('.swiper-button-prev');
  const nextEl = parent.querySelector('.swiper-button-next');

  new Swiper(swiper, {
    modules: [Pagination, Navigation],
    slidesPerView: 'auto',
    spaceBetween: 12,
    loop: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl,
      prevEl,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      // dynamicBullets: true,
      // dynamicMainBullets: 3,
    },
    breakpoints: {
      [lg]: {
        centeredSlides: true,
        slidesPerView: 3,
        spaceBetween: 20,
      },
      [xl2]: {
        centeredSlides: true,
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
  });
}
